import React, { useEffect, useState } from "react";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";
import ProjectsCard from "../Shared/ProjectsCard/ProjectsCard";
import Sidebar from "../Shared/Sidebar/Sidebar";
import { RiArrowDropDownLine } from "react-icons/ri";
import "./MyProjects.css";

const MyProjects = () => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [selectFilter, setSelectFilter] = useState(false);
  const [selectFilterText, setSelectFilterText] = useState("All");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  useEffect(() => {
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  const handleSelectFilter = () => {
    setSelectFilter(!selectFilter);
  };

  const handleAll = () => {
    setSelectFilterText("All");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  };

  const handleUI = () => {
    setSelectFilterText("UI Design");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) =>
        setProjects(data.filter((item) => item.filter.includes("uiDesign")))
      );
  };
  const handleReact = () => {
    setSelectFilterText("React JS");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) =>
        setProjects(data.filter((item) => item.filter.includes("react")))
      );
  };
  const handleFirebase = () => {
    setSelectFilterText("Firebase");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) =>
        setProjects(data.filter((item) => item.filter.includes("firebase")))
      );
  };

  const handleMongo = () => {
    setSelectFilterText("MongoDB");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) =>
        setProjects(data.filter((item) => item.filter.includes("mongodb")))
      );
  };

  const handleWordPress = () => {
    setSelectFilterText("MongoDB");
    setSelectFilter(false);
    setProjects(null);
    fetch("webProjects.json")
      .then((res) => res.json())
      .then((data) =>
        setProjects(data.filter((item) => item.filter.includes("wordpress")))
      );
  };

  return (
    <section>
      <Sidebar></Sidebar>
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div
          className="lg:pl-[220px] min-h-screen"
          onClick={() => setSelectFilter(false)}
        >
          <div className="px-4 lg:px-20 w-full">
            <div className="py-6 lg:py-12">
              <div className="mb-10 lg:mb-12 mt-12 lg:mt-5 space-y-4 lg:space-y-0 lg:flex justify-between items-end">
                <h1 className="animate__animated animate__fadeInDown title-text text-center lg:mt-0 text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                  Things{" "}
                  <span className="text-dark-blue-xxl dark:text-white">
                    I've Built
                  </span>
                </h1>
                <div className="select-dropdown flex justify-center" onClick={(e) => e.stopPropagation()}>
                  <div
                    onClick={handleSelectFilter}
                    className="select-field w-[250px] text-dark-blue-xxl dark:text-[#abb7db] dark:bg-dark-blue border-b-2 border-b-dark-blue-xxl dark:border-b-[#abb7db] first-line:text-sm form-text pl-2 py-1 cursor-pointer flex justify-between items-center"
                  >
                    {selectFilterText}
                    <div
                      className={`select-icon dark:text-[#abb7db] ${
                        selectFilter ? "rotate-180" : "rotate-0"
                      }`}
                    >
                      <RiArrowDropDownLine size={"1.7rem"} />
                    </div>
                  </div>
                  <div
                    className={`options-group form-text ${
                      selectFilter ? "block" : "hidden"
                    }`}
                  >
                    <div onClick={handleAll} className="select-option text-sm">
                      All
                    </div>
                    <div onClick={handleUI} className="select-option text-sm">
                      UI Design
                    </div>
                    <div
                      onClick={handleReact}
                      className="select-option text-sm"
                    >
                      React JS
                    </div>
                    <div
                      onClick={handleFirebase}
                      className="select-option text-sm"
                    >
                      Firebase
                    </div>
                    <div
                      onClick={handleMongo}
                      className="select-option text-sm"
                    >
                      MongoDB
                    </div>
                    <div
                      onClick={handleWordPress}
                      className="select-option text-sm"
                    >
                      WordPress
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-4"
                onClick={() => {
                  setSelectFilter(false);
                }}
              >
                {projects &&
                  projects.map((project) => (
                    <ProjectsCard
                      key={project.id}
                      project={project}
                    ></ProjectsCard>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MyProjects;
